module.exports = __webpack_public_path__ + "media/icons/safe-case-87b5fa88.png";